// @flow
import React, {Component} from 'react';
import {StyleSheet, View} from 'react-native';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';
import {Field} from 'redux-form';
import {Button, Text} from 'trpc-react-native-ui';

import {
  FullButton,
  GradientPage,
  HoshiInput,
  Icon,
} from '../../../components/common';
import {PageTitle, Separator} from '../../../components/signUp';
import config from '../../../config';
import generateSIMReference from '../../../lib/generateSIMReference';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';
import pageStyle from '../styles';

import type {
  NavigationRoute,
  NavigationScreenProp,
} from '@react-navigation/compat';

export default class SIMCardManual extends Component<Props> {
  styles = getStyles();

  componentDidMount() {
    // This screen is for physical SIM cards activation only
    this.props.selectEsim(false);
  }

  goToSIMScanPage = () => this.props.navigation.navigate('simCardScan');

  cheatCode = async () => {
    const simReference = await generateSIMReference(this.props.eSimSelected);
    this.props.change('number', simReference);
    this.props.handleSubmit();
  };

  onPress = async () => {
    this.props.setVoucherDetailsComeFrom('activation');
    this.props.handleSubmit();
  };

  componentWillUnmount() {
    if (
      this.props.currentVoucherDetails &&
      this.props.setCurrentVoucherDetails
    ) {
      this.props.setCurrentVoucherDetails(null);
    }
  }

  render() {
    const styles = this.styles;
    return (
      <GradientPage dismissKeyboard>
        <KeyboardAwareScrollView
          extraHeight={135}
          keyboardShouldPersistTaps="always"
          enableOnAndroid="true">
          <PageTitle
            title={I18n.t('SignUp.SIMCardManual.title')}
            style={pageStyle.title}
          />
          <View style={styles.scanContainer}>
            <Text style={[styles.text, styles.scanDescription]}>
              {I18n.t('SignUp.SIMCardManual.scanDescription')}
            </Text>
            <Button onPress={this.goToSIMScanPage} style={styles.scanButton}>
              <Icon
                name="camera"
                color={theme.signUpIconInCircleColor}
                size={40}
              />
            </Button>
          </View>
          <View style={styles.separator}>
            <Separator
              text={I18n.t('or').toUpperCase()}
              color={theme.separatorColor}
            />
          </View>
          <View style={styles.manualFormContainer}>
            <Text style={styles.text}>
              {I18n.t('SignUp.SIMCardManual.manually')}
            </Text>
            <Field
              name="number"
              component={HoshiInput}
              placeholder={I18n.t('SignUp.SIMCardManual.form.number')}
              returnKeyType="go"
              onSubmitEditing={this.props.handleSubmit}
              wrapperContainerStyle={styles.inputContainer}
              style={styles.input}
              type="digits"
              autoCorrect={false}
              testID="simActivation-serial-input"
              icon={
                this.props.valid && (
                  <Icon
                    name="check"
                    color="green"
                    size={17}
                    style={styles.checkIcon}
                  />
                )
              }
            />
            <Text style={styles.text}>
              {config.areCheatCodesEnabled
                ? 'Faire un appui long sur le bouton ci-dessous pour générer un numéro de SIM aléatoirement'
                : ''}
            </Text>
            <FullButton
              text={I18n.t('confirm')}
              onPress={this.onPress}
              onLongPress={config.areCheatCodesEnabled ? this.cheatCode : null}
              isLoading={this.props.isLoading}
              testID="simActivation-continue-button"
            />
          </View>
        </KeyboardAwareScrollView>
      </GradientPage>
    );
  }
}

type Props = {
  change: Function,
  handleSubmit: Function,
  isLoading: boolean,
  eSimSelected: boolean,
  navigation: NavigationScreenProp<NavigationRoute>,
  putMeterID: Function,
  valid: boolean,
  currentVoucherDetails: Object,
  selectEsim: Function,
};

const SCAN_BUTTON_SIZE = 90;
const getStyles = () =>
  StyleSheet.create({
    text: {
      fontSize: 16,
      textAlign: 'center',
    },
    scanContainer: {
      marginHorizontal: 20,
      alignItems: 'center',
      justifyContent: 'center',
    },
    scanDescription: {
      marginTop: 30,
      marginBottom: 20,
    },
    scanButton: {
      backgroundColor: theme.signUpIconInCircleBackgroundColor,
      borderRadius: SCAN_BUTTON_SIZE / 2,
      width: SCAN_BUTTON_SIZE,
      height: SCAN_BUTTON_SIZE,
      alignItems: 'center',
      justifyContent: 'center',
    },
    separator: {
      marginTop: 42,
    },
    manualFormContainer: {
      marginVertical: 16,
      marginHorizontal: 20,
    },
    inputContainer: {
      marginBottom: 15,
    },
    input: {
      marginVertical: 8,
    },
    checkIcon: {
      backgroundColor: 'transparent',
      marginBottom: 6,
    },
  });
